import $ from 'jquery';

Drupal.behaviors.responsiveText = {
  attach: function () {
    function updateFontBase () {
      const $body = $('body');
      const baseFontSize = parseInt($body.css('font-size'));
      const columnWidthInEms = 50;
      const $articles = $('main');
      const sectionWidth = $articles.find('section.body').eq(0).outerWidth();
      let responsiveBodyRems = sectionWidth / (baseFontSize * columnWidthInEms);

      if (responsiveBodyRems > 0.75) {
        $articles
          .css('font-size', (0.75 + (responsiveBodyRems / 5.5))+'rem');
      }

      else if(responsiveBodyRems <= 0.75) {
        $articles
          .css('font-size', 0.75+'rem');
      }
    }

    $('document').ready( function() {
      updateFontBase();
    });

    $(window).on('resize', function() {
      updateFontBase();
    });
  }
};
